import { render, staticRenderFns } from "./PlaceFilters.vue?vue&type=template&id=376ac182&"
import script from "./PlaceFilters.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PlaceFilters.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('376ac182')) {
      api.createRecord('376ac182', component.options)
    } else {
      api.reload('376ac182', component.options)
    }
    module.hot.accept("./PlaceFilters.vue?vue&type=template&id=376ac182&", function () {
      api.rerender('376ac182', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/lpu/components/PlaceFilters/PlaceFilters.vue"
export default component.exports